import { Button, ButtonVariant } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import updateHistory from "./utils/updateHistory"

/* Protopia Ecosystem component */
export interface IDataDummyProps {
   data: any
   section: ILandingSection
}
const DataDummy = (props: IDataDummyProps): JSX.Element => {
    const isEdit: boolean           = useLandingStore((state: ILandingStore) => state.isEdit )
    const currentLanding: ILanding  = useLandingStore((state: ILandingStore) => state.currentLanding ) 
    const data                      = components()[ props.data.type ] 
    if(!isEdit) {
        return <></>
    }
    const onShow = () => {
        const historyStep: IHistoryStep = {
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Show Meat",
        } 
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map(section => {
                if(props.section.id === section.id) {
                    historyStep.prevData = section
                    historyStep.data     = {
                        ...section,
                        data: section.data.map(data => {
                            if(data.id === props.data.id) {
                                return {
                                    ...data,
                                    isHidden: !data.isHidden,
                                }
                            }
                            return data
                        })
                    }
                    return historyStep.data
                }
                return section
            })
        }
        updateHistory( historyStep, landing ) 
    }
    return <div className=' landing-data-dummy ' onClick={onShow}>
       <Button fill icon={"eye-off"} variant={ButtonVariant.OUTLINED}>
            { __( data.title ) }
       </Button>
    </div>
}
export default DataDummy